import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { dark, light } = theme.palette.primary;

  return {
    root: {
      position: "relative"
    },
    rootSticky: {
      borderRadius: 3,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)"
    },
    header: {
      fontSize: 16,
      [theme.breakpoints.down("sm")]: {
        color: "#595a5a"
      }
    },
    noComments: {
      fontSize: 18,
      color: dark,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 32
    },
    list: {
      background: "#fff",
      borderRadius: 3,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.1)",
      height: "100%"
    },
    listSticky: {
      overflow: "auto",
      borderRadius: "0 0 3px 3px",
      boxShadow: "none"
    },
    comment: {
      padding: "14px 16px"
    },
    footer: {
      borderTop: `1px solid ${theme.palette.primary.light}`
    },
    oddComment: {
      backgroundColor: "rgba(238, 238, 238, 0.25)"
    },
    infiniteLoader: {
      display: "none",
      position: "absolute",
      width: "100%",
      height: 0
    },
    showInfiniteLoader: {
      marginBottom: 20,
      display: "flex",
      alignItems: "flex-end"
    },
    scrollContainer: {
      position: "relative",
      overflowX: "auto",
      overflowY: "scroll",
      height: "100%",
      willChange: "transform",
      direction: "ltr",
      "&::-webkit-scrollbar": {
        width: 0
      }
    },
    addCommentBox: {
      backgroundColor: "#fff",
      borderRadius: 3,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderBottom: `1px solid ${light}`
    },
    emptyComment: {
      height: 99,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    addButton: {
      color: dark,
      fontSize: 16,
      textTransform: "capitalize",
      "& .MuiButton-label": {
        flexDirection: "column",
        alignItems: "center"
      },
      "& .MuiButton-startIcon": {
        marginRight: 0
      }
    },
    addIcon: {
      "&.MuiSvgIcon-root": {
        fontSize: 27
      }
    },
    commentEditor: {
      padding: "24px 16px 32px"
    }
  };
});
